import React from 'react';

import { flagStyles } from '../settings';

const SvgML = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-3432px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgML;
